import ButtonLoader from 'utils/ButtonLoader'

export const AddToCart = async (
  button: HTMLAnchorElement | HTMLButtonElement,
  form: HTMLFormElement
) => {
  const formData = new FormData(form)
  //@ts-ignore
  const dataString = new URLSearchParams(formData).toString()

  button && ButtonLoader.start(button)

  const response = await fetch(form.getAttribute('action'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: dataString
  })

  if (response.status == 200) {
    const data = await response.json()

    if (data.success) {
      // success the button
      button && ButtonLoader.success(button)
    }
    else {
      // reset the button
      button && ButtonLoader.reset(button)
    }
  }
  else {
    button && ButtonLoader.error(button)
  }

  return response
}
